<template>
  <div @click="goAddress">
    <section class="address-info">
      <ul class="flex align-center">
        <li class="flex-1 content" v-if="receiverInfo.addrId">
          <div style="width: 100%; display: inline-flex; align-items: center">
            <p class="address van-multi-ellipsis--l2 flex-1">{{ receiverInfo.address }}</p>
            <li class="link" v-if="isLink">
              <van-icon size="14" color="#bfbfbf" name="cap-arrow" />
            </li>
          </div>
          <span class="name van-multi-ellipsis--l2">
            {{ receiverInfo.name }} &emsp;&emsp;&emsp;&emsp;{{ receiverInfo.mobile }}
          </span>
        </li>
        <li class="flex-1 add inline-flex" v-else>
          <p>添加收货地址</p>
          <van-icon size="14" color="#bfbfbf" name="cap-arrow" />
        </li>
      </ul>
      <div v-if="showNotice" class="address-info__notice">
        <span class="notice-title">温馨提示：</span>
        收货地址中的手机号将用于线下自提验证核销
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    receiverInfo: {
      type: Object,
      default: () => {}
    },
    isLink: {
      type: Boolean,
      default: true
    },
    showNotice: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goAddress() {
      if (this.isLink) {
        Telescope.trackEvent({ trackId: 'zyyd-click-FillOrder-ChooseAddress' });

        this.$router.push({ name: 'AddressList', query: this.$route.query });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.address-info {
  padding: 16px 12px;
  .inline-flex {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
  }
  .content {
    overflow: hidden;
  }
  ul.flex {
    display: flex;
    align-items: center;
  }
  li {
    &.flex-1 {
      flex: 1;
    }
    &.add,
    .address {
      font-size: 18px;
      font-weight: @font-weight-bold;
      color: #262626;
      line-height: 27px;
      flex: 1;
      flex-wrap: wrap;
    }
    span {
      font-size: @font-size-md;
      color: #8c8c8c;
      margin-right: 10px;
    }
    .name {
      font-size: 14px;
      margin-top: 8px;
      line-height: 16px;
    }
    &.link {
      margin-left: 12px;
    }
  }
  &__location {
    width: 32px;
    height: 32px;
    margin-top: 16px;
    line-height: 20px;
  }
  &__notice {
    padding: 8px;
    margin-top: 12px;
    background: #ffeeeb;
    border-radius: 4px;
    font-size: 12px;
    color: #262626;
    .notice-title {
      color: #ff4e47;
    }
  }
}
</style>
